import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate } from 'react-router-dom';
import api from '../services';
import { isAuthLoading, isNotAuthenticated } from './authStateHelpers';

export function withRouter(Component) {
  return function WrappedWithRouter(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const { authState, oktaAuth } = useOktaAuth();

    // Wait for auth state to be determined (helpers honor the dev-only auth bypass)
    if (isAuthLoading(authState)) {
      return <div>Loading...</div>;
    }

    // If not authenticated, redirect to login
    if (isNotAuthenticated(authState)) {
      sessionStorage.setItem('preLoginUrl', location.pathname + location.search);
      return <Navigate to='/login' replace />;
    }

    // Set up API authorization header when authenticated (authState is null when
    // the dev-only auth bypass is active)
    if (authState?.accessToken?.accessToken) {
      api.defaults.headers.common['Authorization'] = `Bearer ${authState.accessToken.accessToken}`;
    }

    // Pass all props including auth state and router props
    return (
      <Component
        {...props}
        location={location}
        navigate={navigate}
        params={params}
        authState={authState}
        oktaAuth={oktaAuth}
      />
    );
  };
}
